<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.save_in_blocks') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row dense>
                    <v-col cols="12">
                        <kimsa-combobox :label="$tc('common.blocks', 2)" outlined dense :items="blockOptions"
                            @change="block = $event" ref="blocks" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field :label="$t('common.name')" outlined dense force-value no-elevation
                            :value="name" @change="name = $event" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-combobox :label="$t('common.folder')" outlined dense :items="folderOptions"
                            @change="folder = $event" ref="folders" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-tags-picker ref="tagsPicker" @change="tags = $event" :default-tags="tags"
                            :label="$t('exercises.tags')" force-value />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-upload-file :label="$t('common.image')" relative-path="images/blocks"
                            mime-types="image/*" @change="file = $event" :preview-img="previewImg" ref="img"
                            height="150" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                    :disabled="disabled" @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { db } from "@/utils/Firebase";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaUploadFile from "@/components/common/inputs/KimsaUploadFile";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { getPayloadBlock } from "@/utils/Exercises";
import KimsaTagsPicker from '../../common/inputs/KimsaTagsPicker.vue';

export default {
    name: "SaveBlockDialog",
    components: { KimsaCombobox, KimsaUploadFile, KimsaTextField, KimsaTagsPicker },
    props: {
        coachId: {
            type: String,
            default: null
        }
    },
    data(vm) {
        return {
            dialog: false,
            loading: false,
            assignedRoutine: null,
            name: '',
            block: null,
            folder: null,
            tags: [],
            file: null,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'folders', 'globalFolders']),
        disabled(vm = this) {
            return !vm.block || !vm.name || !vm.folder;
        },
        previewImg(vm = this) {
            return vm.file?.img || null
        },
        folderOptions(vm = this) {
            return [...vm.globalFolders, ...vm.folders].filter(folder => folder.type === 'blocks' && !folder.isCircuit) || []
        },
        blockOptions(vm = this) {
            return Array.from({ length: vm.assignedRoutine?.blocks?.length || 0 }, (_, i) => i + 1)
        }
    },
    async mounted() {
        const vm = this
        // console.log(vm)
        if (vm.folders.length === 0) await vm.bindFolders(vm.coachId)
        if (vm.globalFolders.length === 0) await vm.bindGlobalFolders()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        ...mapActions(['bindFolders', 'bindGlobalFolders']),
        show(assignedRoutine) {
            const vm = this
            if (!assignedRoutine) return vm.toast(vm.$t('routines.error_save_routine'))
            vm.assignedRoutine = assignedRoutine
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.assignedRoutine = null
            vm.name = ''
            if (vm.$refs.blocks) vm.$refs.blocks.model = null
            if (vm.$refs.folders) vm.$refs.folders.model = null
            if (vm.$refs.img) vm.$refs.img.reset()
            vm.block = null
            vm.folder = null
            vm.tags = []
            vm.file = null
        },
        async save() {
            const vm = this
            vm.loading = true
            const block = vm.assignedRoutine.blocks[vm.block - 1]
            let img = null
            if (vm.file) img = await vm.$refs.img.upload()
            let payload = getPayloadBlock(vm.name, vm.coachId, block, vm.folder, vm.tags, img)
            console.log('payload', payload);
            await db.collection('blocks').add(payload)
            vm.loading = false
            vm.hide()
            vm.toast(vm.$t('common.saved_block'))
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>